<template>
  <div>
    <headerSection></headerSection>
    <div class="reward-page" :style="pageBackgroundStyle">
      <div class="container reward-shell">
        <section class="reward-hero">
          <div class="reward-hero__panel">
            <p class="reward-hero__eyebrow">
              <i class="fas fa-calendar-check"></i>
              Continuous Deposit
            </p>
            <h1 class="reward-hero__title">ฝากต่อเนื่อง</h1>
            <p class="reward-hero__desc">
              ตรวจสอบโบนัสฝากต่อเนื่อง สถานะความต่อเนื่องย้อนหลัง และรับเครดิตเข้า
              กระเป๋าหลักได้ทันทีเมื่อครบเงื่อนไข
            </p>

            <div class="reward-chip-row">
              <span class="reward-chip">
                <i class="fas fa-fire"></i>
                ต่อเนื่อง {{ activeDotCount }} วัน
              </span>
              <span class="reward-chip is-muted">
                <i class="fas fa-clock"></i>
                รับได้ทุกวันเวลา 07:00 น.
              </span>
            </div>
          </div>

          <div class="reward-hero__panel reward-hero__panel--compact">
            <div class="reward-media">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/cow-888.appspot.com/o/images%2F-NMrhI1RhVEcKScH76cF.png?alt=media&token=d3e096b3-2617-44c7-a0af-4f9a19cef294"
                alt="ฝากต่อเนื่อง"
                class="img-fluid"
              >
            </div>

            <div class="reward-note-list">
              <div class="reward-note">
                <i class="fas fa-shield-alt"></i>
                <div>
                  <strong>เงื่อนไขสำคัญ</strong>
                  <span>ต้องมีเครดิตในกระเป๋าหลักต่ำกว่า 5 บาทก่อนรับโบนัส</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="reward-section">
          <div class="reward-section__header">
            <div>
              <h2 class="reward-section__title">สถานะโบนัสวันนี้</h2>
              <p class="reward-section__subtext">
                ชื่อโปรโมชั่น โบนัสที่ได้รับ และความต่อเนื่องย้อนหลัง 30 วัน
              </p>
            </div>

            <span class="reward-chip">
              <i class="fas fa-bolt"></i>
              โบนัส {{ numberWithCommas(continues.total) }}
            </span>
          </div>

          <div class="reward-card-grid">
            <article class="reward-card reward-card--info">
              <p class="reward-card__label">โปรโมชั่น</p>
              <p class="reward-card__value reward-card__value--sm">{{ continuePromotionName }}</p>
              <p class="reward-card__caption">รายการฝากต่อเนื่องที่ระบบตรวจพบล่าสุด</p>
              <div class="reward-card__footer">
                <span class="reward-card__meta">Promotion</span>
                <span class="reward-card__icon">
                  <i class="fas fa-medal"></i>
                </span>
              </div>
            </article>

            <article class="reward-card reward-card--accent">
              <p class="reward-card__label">โบนัสพร้อมรับ</p>
              <p class="reward-card__value">{{ numberWithCommas(continues.total) }}</p>
              <p class="reward-card__caption">โอนกลับเข้ากระเป๋าหลักได้เมื่อผ่านเงื่อนไขเครดิต</p>
              <div class="reward-card__footer">
                <span class="reward-card__meta">Available</span>
                <span class="reward-card__icon">
                  <i class="fas fa-gift"></i>
                </span>
              </div>
            </article>
          </div>

          <article class="reward-card reward-card--span-2" style="margin-top: 16px;">
            <p class="reward-card__label">ความต่อเนื่องย้อนหลัง 30 วัน</p>
            <p class="reward-card__caption">
              ช่องที่สว่างคือวันที่ทำยอดครบเงื่อนไขฝากขั้นต่ำในวันนั้น
            </p>

            <div class="reward-streak">
              <div
                v-for="cell in streakCells"
                :key="cell.day"
                :class="['reward-streak__cell', { 'is-active': cell.active }]"
              >
                <span>Day {{ cell.day }}</span>
                <strong>{{ cell.active ? 'ผ่าน' : 'รอ' }}</strong>
              </div>
            </div>
          </article>

          <div class="reward-action-row">
            <div>
              <button
                type="button"
                :class="['reward-button', { 'is-disabled': !canTransfer }]"
                :disabled="!canTransfer"
                @click="moveContinuesToWallet()"
              >
                <i class="fas fa-exchange-alt"></i>
                โอนเงินเข้ากระเป๋าหลัก
              </button>
              <span class="reward-button__subtext">
                หากเครดิตมากกว่า 5 บาท ระบบจะยังไม่อนุญาตให้รับโบนัส
              </span>
            </div>
          </div>
        </section>

        <section class="reward-section reward-section--compact">
          <div class="reward-note-list">
            <div class="reward-note">
              <i class="fas fa-sun"></i>
              <div>
                <strong>เวลารับโบนัส</strong>
                <span>รับฝากต่อเนื่องได้ทุกวันเวลา 07:00 น. ตามเวลาระบบ</span>
              </div>
            </div>
            <div class="reward-note">
              <i class="fas fa-chart-line"></i>
              <div>
                <strong>การคำนวณความต่อเนื่อง</strong>
                <span>ระบบตรวจสอบจากยอดฝากรายวันย้อนหลังต่อจากวันที่รับโบนัสล่าสุด</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import moment from 'moment-timezone'
import router from './../router'
const axios = require('axios').default

export default {
  name: 'continues',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  data: function () {
    return {
      continues: [],
      dots: []
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    pageBackgroundStyle () {
      return {
        backgroundImage: `linear-gradient(180deg, rgba(7, 13, 28, 0.32) 0%, rgba(7, 13, 28, 0.85) 100%), url(${require('../assets/images/Shiba-BG.jpg')})`
      }
    },
    canTransfer () {
      return !!(this.continues && this.continues.total > 0)
    },
    continuePromotionName () {
      return (this.continues && this.continues.promotion) ? this.continues.promotion.name : 'ฝากต่อเนื่อง 3 วัน'
    },
    activeDotCount () {
      return this.dots.filter(Boolean).length
    },
    streakCells () {
      return Array.from({ length: 30 }, (_, index) => ({
        day: String(index + 1).padStart(2, '0'),
        active: !!this.dots[index]
      }))
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    moveContinuesToWallet () {
      if (this.continues.total && this.continues.key) {
        this.$store.commit('user/SET_LOADING', true)
        this.$store.dispatch('user/moveCreditToWallet').finally(() => {
          if (this.user.credit <= 5) {
            axios.get(`https://api.cow888.fun/qcontinuous/continuous/${this.continues.key}`)
            setTimeout(() => {
              this.getContinues()
              this.$store.commit('user/SET_LOADING', false)
            }, 2000)
          } else {
            this.$swal({ icon: 'error', title: 'เงื่อนไข', text: 'ต้องมีเครดิตต่ำกว่า 5 บาท ถึงรับได้ค่ะ' })
            this.$store.commit('user/SET_LOADING', false)
          }
        }).catch(err => { console.error(err) })
      }
    },
    numberWithCommas (x) {
      if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
    async getContinues () {
      const user = this.getUserId()
      if (user) {
        this.dots = []
        await firebase.firestore().collection('continuous_deposit').where('date', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) {
            this.continues = []
            this.dots = []
          }
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.continues = data
          })
        })

        const fixed = 500
        let last = {}
        await firebase.firestore().collection('continuous_deposit_all').where('userkey', '==', user.key).where('status', '==', true).orderBy('date', 'desc').limit(1).get().then((snapshot) => {
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            last = data
          })
        })
        const dateCheck = []
        if (last && last.date) {
          await firebase.firestore().collection('daily_deposit').where('createdate', '>', last.date).where('createdate', '<=', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(30).get().then((snapshot) => {
            snapshot.forEach((doc) => {
              if (doc.data().total >= fixed) {
                dateCheck[doc.data().createdate] = true
              }
            })
          })
        } else {
          await firebase.firestore().collection('daily_deposit').where('createdate', '<=', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(30).get().then((snapshot) => {
            snapshot.forEach((doc) => {
              if (doc.data().total >= fixed) {
                dateCheck[doc.data().createdate] = true
              }
            })
          })
        }
        if (dateCheck) {
          for (let i = 1; i <= 30; i++) {
            if (dateCheck[moment().tz('Asia/Bangkok').add(-i, 'days').format('YYYY-MM-DD')]) {
              this.dots.push(true)
            } else {
              break
            }
          }
        }
      }
    }
  },
  mounted () {
    this.scrollToTop()
    this.getContinues()
  }
}
</script>
